// Port of api/fuel/app/classes/insights/records/streaks.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Util from 'offline/util'

function packageStreaks(segment, streaks, detail, streakType) {
	var limit = detail ? 100 : 5
	var items = streaks[streakType] || []
	items = Util.sort_by_field(items, 'count', 'desc').slice(0, limit)

	for (var i = 0; i < items.length; i++) {
		segment._references.users.push(parseInt(items[i].user, 10))
		items[i].games = (items[i].games || []).slice(0, 10)
		for (var j = 0; j < items[i].games.length; j++) {
			segment._references.games.push(parseInt(items[i].games[j], 10))
		}
	}

	return items
}

export default Segment.extend({
	name: 'streaks',
	requires: ['init'],
	insight: false,
	methods: {
		records_streaks_analysis: function(type, owner, userIndex) {
			var streaks = {
				win: [],
				loss: [],
				drought: [],
				play: []
			}
			var plays = this._data.plays || []

			if (!plays.length) return streaks

			var currentDate = {}
			var currentResultStreak = {}
			var currentDayStreak = {}

			for (var i = 0; i < userIndex.length; i++) {
				var userId = userIndex[i]
				currentDate[userId] = 0
				currentResultStreak[userId] = {
					user: userId,
					type: 0,
					count: 0,
					date: { first: 0, last: 0 },
					plays: [],
					games: []
				}
				currentDayStreak[userId] = {
					user: userId,
					count: 1,
					date: { first: 0, last: 0 },
					plays: [],
					games: []
				}
			}

			for (var p = 0; p < plays.length; p++) {
				var play = plays[p]
				var currentUser = play.user

				if (currentDate[currentUser] !== play.date && currentDate[currentUser] !== 0) {
					var daysSinceLast = Math.round((play.date - currentDate[currentUser]) / Constants.TIME_DAY)

					if (daysSinceLast <= 1) {
						currentDayStreak[currentUser].count++
					} else {
						streaks.drought.push({
							user: currentUser,
							count: daysSinceLast - 1,
							plays: [],
							games: [],
							date: {
								first: currentDate[currentUser] + Constants.TIME_DAY,
								last: play.date - Constants.TIME_DAY
							}
						})

						streaks.play.push(currentDayStreak[currentUser])

						currentDayStreak[currentUser] = {
							user: currentUser,
							count: 1,
							date: { first: parseInt(play.date, 10), last: 0 },
							plays: [],
							games: []
						}
					}
				}

				currentDayStreak[currentUser].plays.push(parseInt(play.play, 10))
				currentDayStreak[currentUser].games.push(parseInt(play.game, 10))
				if (!currentDayStreak[currentUser].date.first) currentDayStreak[currentUser].date.first = parseInt(play.date, 10)
				currentDayStreak[currentUser].date.last = parseInt(play.date, 10)
				currentDate[currentUser] = play.date

				if (play.result) {
					var playResult = play.won ? 'win' : 'loss'

					if (currentResultStreak[currentUser].type !== playResult || currentResultStreak[currentUser].type === 0) {
						if (currentResultStreak[currentUser].type !== 0) {
							streaks[currentResultStreak[currentUser].type].push(currentResultStreak[currentUser])
						}

						currentResultStreak[currentUser].type = playResult
						currentResultStreak[currentUser].date.first = parseInt(play.date, 10)
						currentResultStreak[currentUser].date.last = parseInt(play.date, 10)
						currentResultStreak[currentUser].count = parseInt(play.count, 10)
						currentResultStreak[currentUser].games = []
						currentResultStreak[currentUser].plays = []
					} else {
						currentResultStreak[currentUser].count += parseInt(play.count, 10)
					}

					if (!currentResultStreak[currentUser].date.first) currentResultStreak[currentUser].date.first = parseInt(play.date, 10)
					currentResultStreak[currentUser].date.last = parseInt(play.date, 10)
					currentResultStreak[currentUser].plays.push(parseInt(play.play, 10))
					currentResultStreak[currentUser].games.push(parseInt(play.game, 10))
				}
			}

			for (var u = 0; u < userIndex.length; u++) {
				var uid = userIndex[u]
				if (currentResultStreak[uid].type !== 0) streaks[currentResultStreak[uid].type].push(currentResultStreak[uid])
				if (currentDayStreak[uid].count) streaks.play.push(currentDayStreak[uid])
			}

			return streaks
		}
	},
	run: function(type, owner, userIndex, detail, filter, vars) {
		var streaks = this.records_streaks_analysis(type, owner, userIndex)

		if (detail) {
			streaks = packageStreaks(this, streaks, detail, vars.streakType)
		} else {
			streaks = {
				win: packageStreaks(this, streaks, detail, 'win'),
				loss: packageStreaks(this, streaks, detail, 'loss'),
				play: packageStreaks(this, streaks, detail, 'play'),
				drought: packageStreaks(this, streaks, detail, 'drought')
			}
		}

		this._data.streaks = streaks

		return {
			streaks: streaks
		}
	}
})
